import type { CSSProperties } from 'react';
import MoreVerticalIconSvg from '../../assets/icons/more_vertical.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const MoreVerticalIcon: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <MoreVerticalIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default MoreVerticalIcon;
